import gql from 'graphql-tag';

import attributionFragment from '../fragments/attributionFragment';

export const queryAttributions = gql`
  query attributions {
    attributions {
      ...attributionFragment
    }
  }
  ${attributionFragment}
`;
export default queryAttributions;
